import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#00ea90";
function UBQ({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path  fillOpacity={0.2} d="M13.661 5.631l5.833 3.051-5.62 3.445zM10.34 18.337l-5.833-3.051 5.62-3.446z" /><path  d="M19.494 15.51l-8.11 4.74v-6.652l8.11-4.916zM4.506 8.46l8.11-4.71v6.626l-8.11 4.91V8.459" /></Svg>;
}
UBQ.DefaultColor = DefaultColor;
export default UBQ;